import { palette } from '@livable/saas-react-components';
import breakpointsFunc from '../breakpointsFunc';
const MuiInput = {
  styleOverrides: {
    input: {
      height: 'initial',
      '&::placeholder': {
        transition: "color ".concat(palette.transitions.short)
      }
    }
  },
  variants: [{
    props: {
      variant: 'menuSearch'
    },
    style: {
      width: '100%',
      padding: '12px',
      fontSize: '18px',
      lineHeight: '24px',
      input: {
        padding: '0',
        '&::placeholder': {
          color: palette.shades[600],
          opacity: '1'
        }
      },
      '&:before': {
        content: 'none'
      },
      '&:after': {
        content: 'none'
      },
      '.MuiInputAdornment-root': {
        marginRight: '0'
      },
      '.MuiSvgIcon-root': {
        marginRight: '8px',
        path: {
          fill: palette.shades[600]
        }
      }
    }
  }, {
    props: {
      variant: 'headerSearch'
    },
    style: {
      zIndex: '2',
      height: '48px',
      width: '560px',
      borderRadius: '4px',
      backgroundColor: palette.shades[250],
      border: '2px solid #EBF0F5',
      transition: "background ".concat(palette.transitions.short),
      fontSize: '18px',
      padding: '0 12px',
      input: {
        padding: '0',
        zIndex: 10,
        '&::placeholder': {
          color: palette.shades[700],
          opacity: '1'
        }
      },
      [breakpointsFunc.breakpoints.down('md')]: {
        width: '420px'
      },
      '&:after': {
        content: 'none'
      },
      '&:before': {
        content: 'none'
      },
      '.MuiInputAdornment-root': {
        marginRight: '0',
        zIndex: '10'
      },
      '.MuiSvgIcon-root': {
        fontSize: '20px',
        marginRight: '8px',
        path: {
          fill: palette.shades[600]
        }
      },
      '&:hover': {
        'input::placeholder': {
          color: palette.shades[700]
        },
        '.MuiSvgIcon-root path': {
          fill: palette.shades[700]
        }
      },
      'input:focus::placeholder': {
        color: palette.shades[800]
      },
      '&.focused': {
        border: "2px solid ".concat(palette.primary.main),
        backgroundPosition: 'top center',
        '.MuiSvgIcon-root path': {
          fill: palette.shades[800]
        }
      }
    }
  }]
};
export default MuiInput;